import template from './wizard_leave_setup_cycle.html';
import tr from '../../lib/default-translator.js';

class WizardLeaveSetupCycle
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.disable_edit = ko.observable(false);
		this.leave_type_id = ko.observable(null);
		//leave cycle details to be saved
		this.cycle_length_number = ko.observable(30);
		this.cycle_length_text = ko.observable('days');
		this.cycle_amount = ko.observable(1.5);
		this.is_earned = ko.observable(false);
		this.is_capping_active = ko.observable(false);
		this.capped_amount = ko.observable(25);
		this.is_switch_type = ko.observable(false);
	}

	close()
	{
		this.dialog.close();
	}

	async back_wizard()
	{
		if (this.leave_type_id())
		{
			this.dialog.close();
			return;
		}

		let data = Object.assign({}, this.dialog.bindings, {
			capped_amount: this.capped_amount(),
			is_capping_active: this.is_capping_active(),
			is_earned: this.is_earned(),
			is_switch_type: this.is_switch_type(),
			cycle_amount: this.cycle_amount(),
			cycle_length_text: this.cycle_length_text(),
			cycle_length_number: this.cycle_length_number()
		});

		this.dialog.close();
		await Grape.dialog.open('WizardLeaveSetupDescription', data);
	}
}

class WizardLeaveSetupCyclePage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new WizardLeaveSetupCycle(this);
	}

	init()
	{
		console.log('bindings', this.bindings);

		// If cycle length is given (i.e. "1 year") then split it up
		if (this.bindings.leave_object?.cycle_length)
		{
			let length_array = this.bindings.leave_object.cycle_length.split(" ");
			this.bindings.cycle_length_number = parseInt(length_array[0]);
			this.bindings.cycle_length_text = length_array[1];
		}

		// Handle leave_type_id
		if (this.bindings.leave_object?.leave_type_id)
			this.viewModel.leave_type_id(this.bindings.leave_object.leave_type_id);
		else if (this.bindings.leave_type_id)
			this.viewModel.leave_type_id(this.bindings.leave_type_id);

		// Handle disable_edit
		if (this.bindings.leave_object?.disable_edit != null)
			this.viewModel.disable_edit(this.bindings.leave_object.disable_edit);

		// Handle cycle_length_number - check direct binding first, then leave_object
		if (this.bindings.cycle_length_number != null)
			this.viewModel.cycle_length_number(parseInt(this.bindings.cycle_length_number));
		else if (this.bindings.leave_object?.cycle_length_number != null)
			this.viewModel.cycle_length_number(parseInt(this.bindings.leave_object.cycle_length_number));

		// Handle cycle_length_text - check direct binding first, then leave_object
		let cycle_text = this.bindings.cycle_length_text || this.bindings.leave_object?.cycle_length_text || 'days';
		
		// Normalize cycle length text
		if (cycle_text === 'day')
			cycle_text = 'days';
		else if (cycle_text === 'mon')
			cycle_text = 'mons';
		else if (cycle_text === 'years')
			cycle_text = 'year';

		this.viewModel.cycle_length_text(cycle_text);

		// Handle cycle_amount - check direct binding first, then leave_object
		if (this.bindings.cycle_amount != null)
			this.viewModel.cycle_amount(parseFloat(this.bindings.cycle_amount));
		else if (this.bindings.leave_object?.cycle_amount != null)
			this.viewModel.cycle_amount(parseFloat(this.bindings.leave_object.cycle_amount));

		// Handle capped_amount - check direct binding first, then leave_object
		if (this.bindings.capped_amount != null)
			this.viewModel.capped_amount(parseFloat(this.bindings.capped_amount));
		else if (this.bindings.leave_object?.capped_amount != null)
			this.viewModel.capped_amount(parseFloat(this.bindings.leave_object.capped_amount));

		// Handle boolean flags - check direct binding first, then leave_object
		if (this.bindings.is_switch_type != null)
			this.viewModel.is_switch_type(this.bindings.is_switch_type);
		else if (this.bindings.leave_object?.is_switch_type != null)
			this.viewModel.is_switch_type(this.bindings.leave_object.is_switch_type);

		if (this.bindings.is_capping_active != null)
			this.viewModel.is_capping_active(this.bindings.is_capping_active);
		else if (this.bindings.leave_object?.is_capping_active != null)
			this.viewModel.is_capping_active(this.bindings.leave_object.is_capping_active);

		if (this.bindings.is_earned != null)
			this.viewModel.is_earned(this.bindings.is_earned);
		else if (this.bindings.leave_object?.is_earned != null)
			this.viewModel.is_earned(this.bindings.leave_object.is_earned);
	}

	async next_wizard()
	{
		let message = '';
		let valid = true;

		if (!this.viewModel.cycle_amount() || this.viewModel.cycle_amount() <= 0)
		{
			message = tr('Please enter a cycle amount greater than or equal to 1');
			valid = false;
		}
		else if (!this.viewModel.cycle_length_number() || this.viewModel.cycle_length_number() <= 0)
		{
			message = tr('Please enter a cycle length greater than or equal to 1');
			valid = false;
		}
		else if (this.viewModel.is_capping_active() && (!this.viewModel.capped_amount() || this.viewModel.capped_amount() <= 0))
		{
			message = tr('Please enter a capping amount greater than or equal to 1 (if capping is active)');
			valid = false;
		}

		if (!valid)
		{
			Grape.alerts.alert({type: 'error', message: message, title: tr('Error')});
			return;
		}

		let data = Object.assign({}, this.bindings, {
			capped_amount: this.viewModel.capped_amount(),
			is_capping_active: this.viewModel.is_capping_active(),
			is_earned: this.viewModel.is_earned(),
			is_switch_type: this.viewModel.is_switch_type(),
			cycle_amount: this.viewModel.cycle_amount(),
			cycle_length_text: this.viewModel.cycle_length_text(),
			cycle_length_number: this.viewModel.cycle_length_number()
		});
		
		this.viewModel.close();
		await Grape.dialog.open('WizardLeaveSetupRoles', data);
	}

	async back_and_save()
	{
		// Update the leave_object with current values
		this.bindings.leave_object.capped_amount = this.viewModel.capped_amount();
		this.bindings.leave_object.is_capping_active = this.viewModel.is_capping_active();
		this.bindings.leave_object.is_earned = this.viewModel.is_earned();
		this.bindings.leave_object.cycle_amount = this.viewModel.cycle_amount();
		this.bindings.leave_object.cycle_length_text = this.viewModel.cycle_length_text();
		this.bindings.leave_object.cycle_length_number = this.viewModel.cycle_length_number();
		this.bindings.leave_object.is_switch_type = this.viewModel.is_switch_type();
		
		// Save the leave_object
		let res = await Grape.fetches.postJSON('/admin/leave_type/save', this.bindings.leave_object);
		
		if (res.status === 'OK')
		{
			await Grape.alerts.alert({type: 'success', message: tr('Changes has been saved'), title: tr('Success')});
			this.viewModel.close();
		}
	}

	is_capping_active_and_disabled_edit()
	{
		return this.viewModel.is_capping_active() && !this.viewModel.disable_edit();
	}

	leave_type_id_and_disabled_edit()
	{
		return this.viewModel.leave_type_id() && !this.viewModel.disable_edit();
	}
}

export default {
	name: 'WizardLeaveSetupCycle',
	dialog_class: WizardLeaveSetupCyclePage,
	template: template,
	template_filename: 'translation/dialogs/wizard_leave_setup_cycle',
	provider: 'ps'
};